import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';

const FILES_BASE_KEY = 'files';

export const filesApi = {
  getDownloadUrl: (fileId: string): Promise<FileDownloadUrlDto> =>
    fetchPrivateApi<FileDownloadUrlDto>('GET', `files/${fileId}/download-url`),
};

export const filesApiQueryKeys = {
  downloadUrl: (fileId: string) =>
    [FILES_BASE_KEY, fileId, 'download-url'] as const,
};

interface FileDownloadUrlDto {
  downloadUrl: string;
}
